export default "__VITE_ASSET__Dd9DX_qu__"